import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UserState {
  user: any | null;
  loading: boolean;
  error: string | null;
  setUser: (user: any) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  logout: () => void;
  loadUserFromStorage: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      loading: false,
      error: null,
      setUser: (user) => set({ user }),
      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error }),
      logout: () => set({ user: null }),
      loadUserFromStorage: () => {
        const storedUser = localStorage.getItem("user-storage");
        if (storedUser) {
          try {
            const parsed = JSON.parse(storedUser);
            if (parsed.state?.user) {
              set({ user: parsed.state.user });
            }
          } catch (error) {
            console.error("Error loading user from storage:", error);
          }
        }
      },
    }),
    {
      name: "user-storage",
      partialize: (state) => ({ user: state.user }),
    }
  )
);
